// Store the element that triggered opening so we can restore focus on close
let cartDrawerTrigger = null;

function toggleCart(doClose = false) {
  const drawer = document.querySelector('#cart-drawer')
  if (!drawer.classList.contains('is-drawer-open') && !doClose) {
    // Store the trigger element before opening
    cartDrawerTrigger = document.activeElement;

    drawer.classList.add('is-drawer-open')
    drawer.classList.add('is-open')
    drawer.removeAttribute('inert')

    // In-cart offer: new impression. Clear the latch, then let a banner that is
    // already in the DOM report itself — its connectedCallback ran while the
    // drawer was still closed and correctly declined to fire then.
    drawer.removeAttribute('data-cart-offer-shown')
    document.querySelector('cart-offer')?._maybeTrackShown?.()
    document.body.style.overflow = 'hidden'
    document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
      item.classList.add('is-animated')
    }, 50)

    // Update aria-expanded on toggle buttons
    document.querySelectorAll('[data-cart-toggle], .action_cart').forEach(btn => {
      btn.setAttribute('aria-expanded', 'true');
    });

    // Trap focus inside the drawer after it becomes visible
    setTimeout(() => {
      const focusTarget = drawer.querySelector('.drawer__close') || drawer;
      trapFocus(drawer, focusTarget);
    }, 100);

    // Add ESC key listener for accessibility
    document.addEventListener('keydown', cartDrawerEscHandler);
  } else {
    // Remove ESC listener
    document.removeEventListener('keydown', cartDrawerEscHandler);

    drawer.classList.add('is-closing')
    drawer.setAttribute('inert', '')
    document.body.style.overflow = ''
    document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
      item.classList.remove('is-animated')
    }, 50)

    // Release focus trap and restore focus to trigger
    removeTrapFocus(cartDrawerTrigger);
    cartDrawerTrigger = null;

    // Update aria-expanded on toggle buttons
    document.querySelectorAll('[data-cart-toggle], .action_cart').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });

    setTimeout(() => {
      drawer.classList.remove('is-drawer-open')
      drawer.classList.remove('is-closing')
      drawer.classList.remove('is-open')
    }, 300)
  }
}

function cartDrawerEscHandler(event) {
  if (event.code.toUpperCase() === 'ESCAPE') {
    toggleCart(true);
  }
}

let upgradeFromVariantId = ''
let upgradeBlock = null

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = 'hidden'
  }, 500)
  window.removeEventListener('transitionend', bodyOverflow)
}


function fetchCart() {
  let section_id = ''
  document.querySelectorAll('.shopify-section-group-header-group').forEach(item => {
    if (item.getAttribute('id').includes('cart-drawer')) {
      section_id = item.getAttribute('id').replace('shopify-section-', '')
    }
  })
  let pathname = location.pathname.split('/')[1]
  if (pathname) {
    pathname = '/' + pathname
  }
  fetch(`${pathname}/cart?section_id=` + section_id)
    .then((response) => response.text())
    .then((response) => {
      document.querySelector('#cart-drawer').classList.remove('is-loading')

      document.querySelector('#cart-drawer').querySelector('.drawer__inner').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML

      console.log('fetchCart toggle')

      setTimeout(() => {
        // OPEN the cart drawer, don't toggle it. toggleCart() closes an already
        // open drawer, so when another path had opened it first (script-free-gift.js
        // does exactly this on cart.requestComplete, guarded the same way) this
        // call shut it again — the drawer appearing and instantly vanishing.
        // Every fetchCart() caller wants "show me the cart"; none relies on the
        // close. Deliberate closes still call toggleCart(true) directly.
        if (!document.querySelector('#cart-drawer').classList.contains('is-drawer-open')) {
          toggleCart()
        }
      }, 0)

      document.querySelector('checkout-btn')?.classList.remove('free-gift-loading')
    })

  fetch(`${pathname}/cart.js`)
    .then((response) => response.json())
    .then((response) => {
      document.querySelectorAll('cart-counter')
        .forEach(item => {
          let count = response.item_count
          const protectionId = Number(item.getAttribute('data-order-protection-id'))

          for (const item of response.items) {
            if (item.product_id === protectionId) {
              count--
            }
          }
          item.updateCount(count)
        })
    })
}


document.addEventListener('DOMContentLoaded', () => {
  let adding = false

  document.addEventListener('theme:product:add', fetchCart)
  document.querySelectorAll(['[data-cart-toggle]', '.continue-shopping']).forEach(item => item.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    toggleCart()
  }))

  document.querySelector('#cart-drawer .drawer__underlay').addEventListener('click', () => {
    toggleCart(true)
  })


  if (!customElements.get('order-protection')) {
    customElements.define('order-protection', class OrderProtection extends HTMLElement {
      constructor() {
        super();
        this.btn = this.querySelector('.toggler-btn')
        this.cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.productId = Number(this.getAttribute('data-id'))
        
        this.initializeProtection()
        this.btn.addEventListener('click', () => this.handleButtonClick())
      }

      initializeProtection() {
        const hasManuallyToggled = localStorage.getItem(`protection_toggled_${this.productId}`)
        const productExists = this.cartJson.items.some(item => item.product_id === this.productId)
        
        // Check if there are any other order-protection products in cart
        const otherProtectionProducts = this.cartJson.items.filter(item => 
          item.product_id !== this.productId && 
          document.querySelector(`order-protection[data-id="${item.product_id}"]`)
        )
        
        // Remove other protection products to ensure only one exists
        if (otherProtectionProducts.length > 0) {
          otherProtectionProducts.forEach(item => {
            CartJS.removeItemById(item.variant_id)
          })
        }
        
        if (productExists) {
          if (this.getAttribute('data-enabled') === 'true') {
            this.btn.classList.add('active')
            this.btn.setAttribute('aria-checked', 'true')
          } else {
            CartJS.removeItemById(this.btn.getAttribute('data-id'))
          }
        } else if (!hasManuallyToggled && this.getAttribute('data-enabled') === 'true') {
          // Auto-add protection if not manually toggled before and enabled by default
          this.btn.classList.add('active')
          this.btn.setAttribute('aria-checked', 'true')
          CartJS.addItem(this.btn.getAttribute('data-id'))
        }
      }

      handleButtonClick() {
        if (window.noCartRefresh) {
          return
        }

        this.btn.classList.toggle('active')
        const isActive = this.btn.classList.contains('active')
        this.btn.setAttribute('aria-checked', isActive ? 'true' : 'false')
        document.querySelector('checkout-btn').classList.add('free-gift-loading')
        window.noCartRefresh = true
        
        // Mark as manually toggled
        localStorage.setItem(`protection_toggled_${this.productId}`, 'true')
        
        if (isActive) {
          // Remove any existing order-protection products before adding new one
          this.removeExistingProtectionProducts()
          CartJS.addItem(this.btn.getAttribute('data-id'))
        } else {
          CartJS.removeItemById(this.btn.getAttribute('data-id'))
        }
      }

      removeExistingProtectionProducts() {
        // Remove all existing order-protection products from cart
        document.querySelectorAll('order-protection').forEach(protection => {
          const existingProductId = Number(protection.getAttribute('data-id'))
          if (existingProductId !== this.productId) {
            // Remove other protection products
            const existingItem = this.cartJson.items.find(item => item.product_id === existingProductId)
            if (existingItem) {
              CartJS.removeItemById(existingItem.variant_id)
            }
          }
        })
      }
    })
  }

})

if (!customElements.get('upsell-block')) {
  customElements.define('upsell-block', class UpsellBlock extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.up-wrap-out .closeit')?.addEventListener('click', (event) => {
        document.querySelector('.activeupsell').classList.remove('activeupsell')
        document.body.style.overflow = ''
      })

      this.querySelectorAll(['.up-wrap-out .open-cart', '.up-wrap-out .closeit']).forEach(item => item.addEventListener('click', (event) => {
        document.querySelector('.activeupsell')?.classList.remove('activeupsell')
        document.body.style.overflow = ''
        fetchCart()
      }))

      this.querySelector('.up-wrap-out .btns.cart')?.addEventListener('click', (event) => {
        CartJS.removeItemById(upgradeFromVariantId)
        CartJS.addItem(event.target.closest('.cart-btn').getAttribute('data-upsell-id'), 1)
      })

    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();


      const productId = this.getAttribute('data-product-id')


      document.querySelectorAll('free-gift-product').forEach(item => {
        const freeGiftProduct = item.querySelector('#free-products') ? JSON.parse(item.querySelector('#free-products')?.innerHTML) : null
        if (freeGiftProduct?.find(item => item.id === Number(productId))) {
          this.querySelector('.cart_item_remove').style.display = 'none'
          this.querySelector('.cart__quantity').style.display = 'none'
        }
      })

      this.querySelector('.cart_item_remove').addEventListener('click', (event) => {
        // event.target.classList.add('free-gift-loading')
        document.querySelector('cart-drawer').classList.add('is-loading')

        const btn = event.target.closest('.cart_item_remove')

        CartJS.removeItem(btn.getAttribute('data-line'))
      })

      this.querySelector('.cart__quantity-minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.cart__quantity-plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })

    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        // this.querySelector('.cart_item_remove').classList.add('free-gift-loading')
        document.querySelector('cart-drawer').classList.add('is-loading')
        CartJS.updateItem(this.querySelector('.cart_item_remove').getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', class QuickAdd extends HTMLElement {
    constructor() {
      super();

      this?.addEventListener('click', event => {
        if (this.adding) {
          return
        }

        this.classList.add('free-gift-loading')
        event.preventDefault()
        event.stopPropagation()

        const formData = new FormData(event.target.closest('form'))

        this.adding = true

        fetch('/cart/add', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            fetchCart()
            this.adding = false
          })
      })
    }

    adding = false;

    updateBtn() {

      this.querySelector('button').classList.add('is-added')
      this.querySelector('button').addEventListener('transitionend', this.resetButton.bind(this))

      if (window.displayUpgrade) {
        upgradeBlock.classList.add('activeupsell')
        window.addEventListener('transitionend', bodyOverflow)
        window.scrollTo(0, 0)
        window.displayUpgrade = false
      }

      $(document).off('cart.requestComplete', this.updateBtn.bind(this))
    }

    resetButton() {
      this.querySelector('button').classList.remove('is-loading')
      this.querySelector('button').classList.remove('is-added')
      this.querySelector('button').removeEventListener('transitionend', this.resetButton)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.drawer__close').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-counter')) {
  customElements.define('cart-counter', class CartHeader extends HTMLElement {
    constructor() {
      super();

      if (document.querySelector('order-protection')) {
        this.setAttribute('data-order-protection-id', document.querySelector('order-protection').getAttribute('data-id'))
      }

      if (document.querySelector('#cart-json')) {
        this.cartJson = JSON.parse(document.querySelector('#cart-json').innerHTML)

        let currentCount = this.cartJson.item_count

        const protectionId = Number(this.getAttribute('data-order-protection-id'))

        for (const item of this.cartJson.items) {
          if (item.product_id === protectionId) {
            currentCount--
          }
        }

        this.updateCount(currentCount)
      }
    }

    cartJson = null

    updateCount(count) {
      if (count === 0) {
        this.style.display = 'none'
        return
      }

      this.innerHTML = count
      this.style.display = 'flex'
    }
  })
}




/* ── In-cart offer banner ──────────────────────────────────────────────
   Lives here rather than in a new asset: this file already defines the cart's
   custom elements (cart-item, upsell-block, quick-add, cart-counter), it is
   already loaded on every page, and the banner is one click handler. A seventh
   cart file would cost a request and bytes for no separation benefit.

   It MUST be a custom element. script-free-gift.js replaces the whole of
   #cart-drawer .drawer__inner on cart.requestComplete, which destroys every
   listener inside it — a plain addEventListener would work once and then
   silently stop after the first cart change. connectedCallback re-binds on
   each render, the same reason cart-item is an element.

   Markup and styles: snippets/cart-offer.liquid. */
if (!customElements.get('cart-offer')) {
  customElements.define('cart-offer', class CartOffer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return
      this._bound = true

      this.button = this.querySelector('[data-cart-offer-add]')
      this.errorEl = this.querySelector('[data-cart-offer-error]')
      if (!this.button) return

      this.button.addEventListener('click', this._add.bind(this))
      this._maybeTrackShown()
    }

    /* One cart_offer_shown per cart-drawer OPEN, not per element construction.

       Two things make that non-trivial. The cart drawer markup exists on every
       page load while closed, so connecting is not the same as being seen. And
       .drawer__inner is re-rendered several times per open (fetchCart, then
       script-free-gift's cart.requestComplete handler, then order-protection's
       auto-add), each time constructing a fresh element — so a per-instance
       flag counts three impressions for one.

       The latch therefore lives on #cart-drawer, which is NOT replaced by the
       innerHTML swap, and toggleCart() clears it when the drawer opens. */
    _maybeTrackShown() {
      const drawer = document.querySelector('#cart-drawer')
      if (!drawer || !drawer.classList.contains('is-drawer-open')) return
      if (drawer.hasAttribute('data-cart-offer-shown')) return
      drawer.setAttribute('data-cart-offer-shown', '')
      this._track('cart_offer_shown')
    }

    disconnectedCallback() {
      clearTimeout(this._watchdog)
    }

    /* Duplicated deliberately from assets/top-drawer.js. There is no module
       system here and exposing it as a global to share ~12 lines would couple
       two independent components. Keep the two copies in step. */
    _gaClientId() {
      try {
        const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]*)/)
        if (!match) return null
        const parts = decodeURIComponent(match[1]).split('.')
        if (parts.length < 4) return null
        const clientId = parts.slice(-2).join('.')
        return /^\d+\.\d+$/.test(clientId) ? clientId : null
      } catch (e) {
        return null
      }
    }

    _money(cents) {
      const n = Number(cents)
      return Number.isFinite(n) ? Number((n / 100).toFixed(2)) : 0
    }

    _track(name, extra) {
      try {
        const analytics = window.Shopify && window.Shopify.analytics
        if (!analytics || typeof analytics.publish !== 'function') return
        const payload = {
          offer_product: this.getAttribute('data-offer-product') || '',
          offer_variant_id: this.getAttribute('data-offer-variant-id') || '',
          offer_price: this._money(this.getAttribute('data-offer-price-cents')),
          offer_saving: this._money(this.getAttribute('data-offer-saving-cents')),
          offer_source: this.getAttribute('data-offer-source') || '',
          market: this.getAttribute('data-market') || '',
          cart_item_count: Number(this.getAttribute('data-cart-item-count') || 0),
          cart_subtotal: this._money(this.getAttribute('data-cart-subtotal-cents'))
        }
        const clientId = this._gaClientId()
        if (clientId) payload.ga_client_id = clientId
        analytics.publish(name, Object.assign(payload, extra || {}))
      } catch (e) {
        /* analytics must never break the cart */
      }
    }

    _setError(message) {
      if (!this.errorEl) return
      this.errorEl.textContent = message || ''
      this.errorEl.hidden = !message
    }

    _stopLoading() {
      clearTimeout(this._watchdog)
      this.button.classList.remove('free-gift-loading')
      this.button.removeAttribute('aria-busy')
    }

    /* Adds through CartJS so the queue still emits cart.requestComplete, which
       script-free-gift.js listens for to re-render .drawer__inner in place.
       That is also why nothing here calls fetchCart(): the drawer is already
       open, the re-render leaves it open, and the banner removes itself
       server-side because the offer product is now in the cart. */
    _add() {
      const variantId = this.getAttribute('data-offer-variant-id')
      if (!variantId || this.button.classList.contains('free-gift-loading')) return

      this._setError('')
      this.button.classList.add('free-gift-loading')
      this.button.setAttribute('aria-busy', 'true')

      clearTimeout(this._watchdog)
      this._watchdog = setTimeout(() => {
        this._stopLoading()
        this._setError('That took too long — your cart is unchanged.')
        this._track('cart_offer_failed', { error_message: 'watchdog timeout' })
      }, 12000)

      CartJS.addItem(variantId, 1, {}, {
        success: () => {
          // Success only. A click that fails is not an acceptance.
          this._track('cart_offer_accepted')
          this._stopLoading()
        },
        error: (xhr) => {
          let message = 'Sorry — this offer is unavailable right now.'
          try {
            const body = xhr && (xhr.responseJSON || JSON.parse(xhr.responseText))
            if (body && body.description) message = body.description
          } catch (e) {
            /* keep the generic message */
          }
          this._stopLoading()
          this._setError(message)
          this._track('cart_offer_failed', { error_message: message })
        }
      })
    }
  })
}
